(() => {
  const initialized = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('.lock-catalog').forEach(catalog => {
      if (initialized.has(catalog)) return;
      initialized.add(catalog);
      if ('IntersectionObserver' in window) {
        const sections = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            catalog.querySelectorAll('.lc-nav a').forEach(link => {
              if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-10% 0px -55% 0px' });
        catalog.querySelectorAll('.lc-family, .lc-spec-wrap').forEach(el => sections.observe(el));
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
